<app-top-bar></app-top-bar>

<div class="container">
    <router-outlet></router-outlet>
</div>